var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    {
      attrs: { buttons: _vm.buttons, permissions: _vm.permissions },
      on: { openAddress: _vm.openAddress, openAddressMap: _vm.openFullMap }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v(" " + _vm._s(_vm.$l10n.__("Adresses")) + " ")
      ]),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "relative ovy-auto" },
          [
            _c("preloader", {
              staticClass: "mt-3",
              attrs: { display: _vm.loading }
            }),
            _vm._v(" "),
            !_vm.loading && _vm.items.length > 0
              ? _c(
                  "div",
                  { staticClass: "flex-column" },
                  [
                    _vm.mainInvoicing.length > 0
                      ? _c(
                          "section",
                          { staticClass: "mb-3" },
                          [
                            _c("h4", { staticClass: "mt-0" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__("Adresse de facturation")
                                  ) +
                                  "\n                        " +
                                  _vm._s(
                                    _vm.sameInvoicingAndDeliveryAddress
                                      ? _vm.$l10n.__(" et livraison")
                                      : ""
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.mainInvoicing, function(item, index) {
                              return _c("address-card", {
                                key: index,
                                staticClass: "well relative mb-3",
                                attrs: {
                                  data: item,
                                  permissions: _vm.permissions
                                },
                                on: { "emit-call": _vm.call }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mainDelivery.length > 0 &&
                    !_vm.sameInvoicingAndDeliveryAddress
                      ? _c(
                          "section",
                          { staticClass: "mb-3" },
                          [
                            _c("h4", { staticClass: "mt-0" }, [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Adresse de livraison"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.mainDelivery, function(item, index) {
                              return _c("address-card", {
                                key: index,
                                staticClass: "well relative mb-3",
                                attrs: {
                                  data: item,
                                  permissions: _vm.permissions
                                },
                                on: { "emit-call": _vm.call }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otherAddresses.length > 0
                      ? _c(
                          "section",
                          { staticClass: "mb-3" },
                          [
                            _c("h4", { staticClass: "mt-0" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Autres adresses")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.otherAddresses, function(item, index) {
                              return _c("address-card", {
                                key: index,
                                staticClass: "well relative mb-3",
                                attrs: {
                                  data: item,
                                  permissions: _vm.permissions
                                },
                                on: { "emit-call": _vm.call }
                              })
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("address-map", {
                      attrs: {
                        addresses: _vm.items,
                        corpAddress: _vm.mainCorpAddress,
                        visible: _vm.fullMapVisible
                      },
                      on: { close: _vm.closeFullMap }
                    })
                  ],
                  1
                )
              : _c("div", [
                  !_vm.loading
                    ? _c("div", { staticClass: "placeholder" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(this.$l10n.__("Aucune adresse définie"))
                          )
                        ])
                      ])
                    : _vm._e()
                ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }